import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Image, Text } from '@user-portal/wikr-components';

import SolidPaymentForm from 'components/SolidPaymentForm';
import Modal from 'components/Modal';
import ContactUsLink from 'components/ContactUsLink';

import attention from 'assets/img/webp/attention.webp';

import { ErrorModalWithPaymentProps } from './types';

const ErrorModalWithPayment = ({ onClose }: ErrorModalWithPaymentProps) => {
    const { t } = useTranslation();

    return (
        <Modal paddingX={16} paddingY={16} buttonWithBackground isOpen onClose={onClose} withCloseButton>
            <Box $paddingTop={56} $paddingBottom={12}>
                <Image src={attention} alt="attention" center maxWidth={48} mb={12} />
                <Text center mb={24}>
                    {t('subscription.cancelFlow.commitment.chargeErrorModal.subtitle')}
                </Text>
                <SolidPaymentForm />
                <ContactUsLink boldText />
            </Box>
        </Modal>
    );
};

export default ErrorModalWithPayment;
